import { RoofContainer } from '@paragon/contract-library';
import { Polygon2D } from '@paragon/geometry-library';
import { findNonBoundaryEdgesProjectedTo2D } from '@paragon/layout';
import { notNullish } from '@paragon/utilities';

import { projectSolidDataToPolygon2D } from '../mesh-data-operations';

export function getRidgeLinesForRoofContainer(roofContainer: RoofContainer, basePolygons: readonly Polygon2D[]) {
  if (roofContainer.solidData != null) {
    return findNonBoundaryEdgesProjectedTo2D(roofContainer.solidData, basePolygons);
  }

  console.warn(
    `Unable to access ridge lines for roof container ${roofContainer.name}. Not all snaps will work as expected.`,
  );
  return [];
}

export function getOverhangAreasForRoofContainer(roofContainer: RoofContainer) {
  if (roofContainer.overhangSolidDataList != null) {
    return roofContainer.overhangSolidDataList.filter(notNullish).map(projectSolidDataToPolygon2D);
  }

  console.warn(
    `Unable to access overhang data for roof container ${roofContainer.name}. Not all snaps will work as expected.`,
  );
  return [];
}
